import { Eye, ShieldCheck, MessageSquare, CheckCircle2, Heart, Award } from "lucide-react";
import { useT } from "@/context/ContentContext";

const DEFAULTS = [
    { icon: Eye, t: "Clareza.", d: "Antes de começar, procuramos que esteja claro o que vamos fazer." },
    { icon: ShieldCheck, t: "Responsabilidade.", d: "Assumimos aquilo com que nos comprometemos." },
    { icon: MessageSquare, t: "Comunicação.", d: "Não tem de andar atrás de nós para saber o que se passa na sua obra." },
    { icon: CheckCircle2, t: "Verdade.", d: "Os problemas são comunicados, não escondidos." },
    { icon: Heart, t: "Respeito.", d: "Tratamos cada imóvel com o cuidado que merece." },
    { icon: Award, t: "Excelência.", d: "Não procuramos simplesmente que fique feito. Procuramos que fique bem feito." },
];

export default function HomeCodigoH() {
    const t = useT();
    return (
        <section className="py-16 sm:py-24 bg-[hsl(var(--forest-deep))] text-white">
            <div className="max-w-6xl mx-auto px-6 sm:px-10">
                <div className="eyebrow-light mb-6"><span className="logo-mark text-sm text-white">H<span className="dot !text-[hsl(var(--copper))]">.</span></span> {t("codigo.eyebrow", "Código H.")}</div>
                <h2 className="font-display text-3xl sm:text-5xl font-bold tracking-tight leading-[1.05] max-w-3xl">
                    {t("codigo.title", "A nossa forma de")} <span className="font-serif-italic text-[hsl(var(--copper))]">{t("codigo.title_accent", "fazer obras")}</span><span className="text-[hsl(var(--copper))]">.</span>
                </h2>
                <p className="text-white/70 text-lg mt-6 max-w-2xl">
                    {t("codigo.subtitle", "Seis princípios que orientam cada decisão.")}
                </p>
                <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4 mt-14">
                    {DEFAULTS.map((c, i) => (
                        <div key={i} className="bg-white/5 border border-white/10 rounded-3xl p-7 hover:bg-white/10 transition" data-testid={`codigo-${i + 1}`}>
                            <div className="w-11 h-11 rounded-full bg-[hsl(var(--copper))] flex items-center justify-center mb-5">
                                <c.icon className="w-5 h-5 text-white" />
                            </div>
                            <h3 className="font-display text-xl font-bold mb-2">{t(`codigo.p${i + 1}.title`, c.t)}</h3>
                            <p className="text-white/70 text-sm leading-relaxed">{t(`codigo.p${i + 1}.short`, c.d)}</p>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
